import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VisualizarAlertasComponent } from './visualizar-alertas/visualizar-alertas.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UtilModule } from '../util/util.module';
import { VisualizarAlertasExpedienteComponent } from './visualizar-alertas-expediente/visualizar-alertas-expediente.component';
import { VisualizarAlertasTramitesComponent } from './visualizar-alerta-tramites/visualizar-alertas-tramites.component';
import {TranslatePipe} from "@ngx-translate/core";

@NgModule({
  declarations: [
    VisualizarAlertasComponent,
    VisualizarAlertasExpedienteComponent,
    VisualizarAlertasTramitesComponent,
  ],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, UtilModule, TranslatePipe],
  exports: [
    VisualizarAlertasComponent,
    VisualizarAlertasExpedienteComponent,
    VisualizarAlertasTramitesComponent,
  ],
})
export class AlertaModule {}
